export default __webpack_public_path__ + "static/media/img-not-found.46929394.png";